/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SelectSubtractIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Select Subtract',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M30 14v-2h2v3.111a.889.889 0 0 1-.889.889H28v-2ZM14 30v-2h2v3.111a.889.889 0 0 1-.889.889H12v-2ZM4 20h2v5H4zM4 12h2v5H4zM6 30v-2H4v3.111a.889.889 0 0 0 .889.889H9v-2ZM31.111 4H27v2h3v3h2V4.888A.888.888 0 0 0 31.111 4ZM19 4h5.001v2H19zM11 4h5.001v2H11zM8 4H5a1 1 0 0 0-1 1v4h2V6h2ZM14 21h2v4h-2zM21 14h4.001v2H21zM18 14h-3a1 1 0 0 0-1 1v3h2v-2h2Z"
    />
  </svg>`;
};
